import React from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import { makeStyles } from '@material-ui/core/styles';
import { getTimeRemaining } from '../../../utils/dateTime/DueDateCountDown';

const useStyles = makeStyles(() => ({
  icon: {
    marginRight: '0.4rem',
    marginBottom: '0.1rem',
    height: '24px',
    width: '24px'
  },

  textDays: {
    wordSpacing: '1px',
    fontSize: '1.125rem',
    lineHeight: '1.125rem'
  }
}));

export const DueDate = ({ dueDate, t }) => {
  const { dueDateClasses, days } = getTimeRemaining(dueDate);
  const classes = useStyles();
  return (
    <div className={classes.textDays}>
      <p className={`${dueDateClasses} due-date-format`}>
        <WarningIcon className={classes.icon} hidden={days >= 0} />
        {`${Math.abs(days)} ${t('assessment.dueDate.days')}`}
        {days < 0 ? <> {t('assessment.dueDate.overdue')} </> : <> {t('assessment.dueDate.left')}</>}{' '}
      </p>
    </div>
  );
};
